import React from 'react';

/**
 * NexumiLogo — Marka zyrtare Nexuma (vektor 1:1 me asetin e brendit).
 *
 * Ikona interlocking "✕" (teal) qëndron e lirë — PA kuti — pranë wordmark-ut
 * "nexuma" (navy). Vektori vjen direkt nga `Logo Nexuma_SVG`.
 *
 * Props:
 *   height       — lartësia e logos (default: 32)
 *   variant      — 'dark'  → ikon teal + tekst navy  (sfond i çelët)
 *                | 'light' → ikon teal + tekst i bardhë (sfond i errët)
 *                | 'mono'  → gjithçka e bardhë (sfond shumë i errët)
 *   showWordmark — false → vetëm ikona (default: true)
 *   style        — stil shtesë mbi <svg>
 */

// ── Ikona interlocking "✕" (cls-2 në asetin origjinal) ──────────────────────
export const ICON_PATHS = [
  'M368.46,305H313a84.52,84.52,0,0,1-60.14-24.91L58.08,85.26a1.58,1.58,0,0,0-1.1-.45H1.15V1.31H57a84.46,84.46,0,0,1,60.14,24.91L311.94,221a1.5,1.5,0,0,0,1.09.46h55.43Z',
  'M57,305H1.15v-83.5H57a1.54,1.54,0,0,0,1.1-.46l50.56-50.5,59,59.08L117.11,280.1A84.52,84.52,0,0,1,57,305Z',
  'M261.39,135.9l-59-59.06L252.9,26.21A84.47,84.47,0,0,1,313,1.31h54.82v83.5H313a1.5,1.5,0,0,0-1.09.46Z',
];

// ── Wordmark "nexuma" (cls-1 në asetin origjinal) ───────────────────────────
export const WORDMARK_PATHS = [
  'M431.77,221.76V111.17H418.52V84.67h27.42v21h9.59A46.39,46.39,0,0,1,475,88.21q12.33-6.06,29-6.06,26.5,0,41.82,15.2T561.1,137.9v83.86H535.51V142.25q0-18.51-9.94-28.11t-29.14-9.59q-19,0-29,9.59t-10.06,28.11v79.51Z',
  'M652.72,224.5q-21.48,0-37.24-8.8a60.2,60.2,0,0,1-24.34-25q-8.57-16.23-8.57-37.93t8.57-37.59a60.35,60.35,0,0,1,24.11-24.56q15.53-8.69,36.33-8.69,19.88,0,34.38,8a56,56,0,0,1,22.51,22.62q8,14.63,8,34.73v10.28H607.25Q608.39,179,620.39,191t32.1,12q13.93,0,23.54-5.82A30.18,30.18,0,0,0,689.28,180h26.05q-5,21.24-21.6,32.9T652.72,224.5Zm-44.56-85.68h83.63q-1.83-16.9-12.45-26.28t-28-9.37q-17.15,0-28.56,9.37T608.16,138.82Z',
  'M717.61,221.76,772,151.39,720.35,84.67h28.34l38.84,49.81,38.84-49.81h27.88l-51.64,66.72L857,221.76H828l-41.13-53.24-40.9,53.24Z',
  'M921.65,224.27q-26.5,0-41.58-14.73T865,169.89V84.67h25.59v79.74q0,18.51,9.59,28t27.88,9.48q19.43,0,30.05-9.94t10.62-27.76V84.67h25.59V195.26h13.25v26.5H980.15v-21h-9.6a48,48,0,0,1-19.65,17.48Q938.56,224.27,921.65,224.27Z',
  'M1031.78,221.76V111.17h-13.25V84.67H1046v21h11a40.66,40.66,0,0,1,17.25-17.48q11.31-6.06,27.3-6.06,16.23,0,27.54,6.4t18.16,19.65h.69q14.39-26,47.29-26,25.36,0,39.53,14.63T1248.85,137v84.77h-25.59V140.65q0-36.11-35.19-36.1-35,0-35,36.1v81.11h-25.59V140.65q0-36.11-35.19-36.1-17.13,0-26,9.25t-8.91,26.85v81.11Z',
  'M1318.76,224.27q-23.29,0-36.67-11.54t-13.36-30.27q0-19.65,13.25-30.5t38.15-10.86H1367v-6.17q0-31.75-35-31.76-28.57,0-34.51,21.48H1271.7q3.42-20.33,19.53-31.53t41.24-11.2q28.56,0,43.76,13.49t15.19,38.84v61h12.34v26.5h-27.42v-21h-9.59A49.22,49.22,0,0,1,1347.33,218Q1335,224.28,1318.76,224.27Zm3.43-20.56a50.79,50.79,0,0,0,22.62-5A40.93,40.93,0,0,0,1361,185a32.88,32.88,0,0,0,6-19v-6.17h-45.25q-28.79,0-28.79,21.48,0,10.27,7.77,16.33T1322.19,203.71Z',
];

const FULL_VB = '0 0 1405.27 306.38';   // ikon + wordmark
const ICON_VB = '0 0 369.61 306.38';     // vetëm ikona
const FULL_RATIO = 1405.27 / 306.38;     // ≈ 4.587
const ICON_RATIO = 369.61 / 306.38;      // ≈ 1.206

export default function NexumiLogo({
  height = 32,
  variant = 'dark',
  showWordmark = true,
  style = {},
}) {
  const isLight = variant === 'light';
  const isMono  = variant === 'mono';

  const iconFill = isMono ? '#FFFFFF' : '#4893A5';
  const textFill = (isLight || isMono) ? '#FFFFFF' : '#303D50';

  const ratio = showWordmark ? FULL_RATIO : ICON_RATIO;
  const width = Math.round(height * ratio);

  return (
    <svg
      height={height}
      width={width}
      viewBox={showWordmark ? FULL_VB : ICON_VB}
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Nexuma"
      style={{ display: 'block', flexShrink: 0, height, width, ...style }}
    >
      {showWordmark && WORDMARK_PATHS.map((d, i) => (
        <path key={`w${i}`} d={d} fill={textFill} />
      ))}
      {ICON_PATHS.map((d, i) => (
        <path key={`i${i}`} d={d} fill={iconFill} />
      ))}
    </svg>
  );
}
